module.exports = __webpack_public_path__ + "img/history.2c3daf9b.svg";